<template>
    <div>
        <vue-headful title="Subcontractors :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-id-badge"></i> Subcontractors</li>
                <li class="ml-3">
                    <router-link v-if="this.$root.hasPermission(['subcontractors.manage', 'subcontractors.edit'])" :to="`/subcontractors/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                </li>
                <li class="ml-1">
                    <router-link v-if="this.$root.hasPermission(['subcontractors.manage', 'subcontractors.edit'])" :to="`/subcontractors/import`" class="btn btn-sm btn-primary"><i class="fa fa-file-excel-o"></i> Import</router-link>
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'subcontractorFilters'" />

        <div class="card">
            <div class="card-body">
                <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                <subcontractor-list v-else ref="subIndexList" :allowFilterSaving="true" :custom_fields="custom_fields" :filterId="(filter_id ? parseInt(filter_id) : null)" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
                loading: true,
                custom_fields: {},
            }
        },

        methods: {
            getCustomFields(){
                //Fetch
                this.$http.get('subcontractors/custom-fields')
                    .then(response => {
                        //Set it
                        this.custom_fields = response.data.custom_fields;

                        //Loading
                        this.loading = false;
                    })
                    .catch(err => {
                        //Log the error
                        console.log(err);
                    });
            },
        },

        mounted(){
            //Focus on the SEarch Input
            //this.$refs.subIndexList.$refs.subcontractorTable.$refs.genericFilter.focus();

            //Get the custom fields
            this.getCustomFields();
        }
    }
</script>
